import { Link, List, ListItem, Tooltip } from '@material-ui/core'
import { ElementType } from 'react'

export interface Tag {
  link: string
  title: string
}
interface Props {
  tags: Tag[]
  LinkComponent?: ElementType
  onLinkClick?: (link: string, option: any) => void
}
export function TagCloud({ tags, onLinkClick, LinkComponent }: Props) {
  return (
    <List className="faq-tag-cloud">
      {tags.map(tag => {
        const props = {
          to: tag.link,
          onClick: onLinkClick ? () => onLinkClick(tag.link, {}) : undefined,
          component: LinkComponent,
        }
        return (
          <ListItem<any> key={tag.link} className="faq-tag-cloud__item" component="li">
            <Tooltip title={tag.title}>
              <Link
                color="textSecondary"
                underline="none"
                className="faq-tag-cloud__item__link"
                {...props}
              >
                {tag.title}
              </Link>
            </Tooltip>
          </ListItem>
        )
      })}
    </List>
  )
}
